// extracted by mini-css-extract-plugin
module.exports = {"container":"authorProfile-module--container--25Odw","avatar":"authorProfile-module--avatar--3n5jd","content":"authorProfile-module--content--1J18w"};